import Lottie from "lottie-react";
// import { Autoplay } from "swiper";
import loader from "../../ooredoo_Loader.json";
const Loadingcomponent = ({ type, message, width, marginTop }) => {


    return <div style={{textAlign:'center'}}>
        {/* {message} */}
        <div style={{width: width ? width : '12%',height: '11%', textAlign:'center', margin: marginTop ? `${marginTop}px auto 0px`: "0px auto"}}>
        <Lottie animationData={loader} loop={true} />
        </div>
    </div>
}
export default Loadingcomponent;